function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#74DAFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0070DF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-2",
  x: 0,
  y: 0,
  width: 64,
  height: 64,
  rx: 32
}), /*#__PURE__*/React.createElement("filter", {
  x: "-85.9%",
  y: "-54.7%",
  width: "271.9%",
  height: "271.9%",
  filterUnits: "objectBoundingBox",
  id: "filter-3"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 20,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.329350825 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "10.10\\u6700\\u7EC8",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5F00\\u53D1\\u8005\\u670D\\u52A1\\u5E73\\u53F0-10.14",
  transform: "translate(-1140.000000, -1311.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-16",
  transform: "translate(-92.000000, 1273.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-3",
  transform: "translate(457.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "cddc",
  transform: "translate(805.000000, 48.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u77E9\\u5F62"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-3)",
  xlinkHref: "#path-2"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#linearGradient-1)",
  fillRule: "evenodd",
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u4EA7\\u54C1\\u56FE\\u6807/ddh-\\u4E13\\u6709\\u5BBF\\u4E3B\\u673A",
  transform: "translate(16.000000, 16.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5F62\\u72B6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.66,9.24 L14.24,3.16 L14.24,0.16 L0.16,7.58 L0.16,24.42 L14.24,31.84 L14.24,28.84 L2.66,22.76 L2.66,9.24 Z M17.76,0.16 L17.76,3.16 L29.34,9.24 L29.34,22.74 L17.76,28.82 L17.76,31.82 L31.84,24.4 L31.84,7.58 L17.76,0.16 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,5.08 L5.24,10.42 L16,15 L26.76,10.42 L16,5.08 Z M27.24,11.84 L16.9,16.58 L16.9,20.82 L27.24,15.9 L27.24,11.84 Z M27.24,17.76 L16.9,22.52 L16.9,26.52 L27.24,21.52 L27.24,17.76 Z M15.08,16.58 L4.76,11.84 L4.76,15.92 L15.1,20.76 L15.1,16.58 L15.08,16.58 Z M12.16,18.42 C11.58,18.34 11.08,17.76 11.08,17.18 C11.08,16.6 11.58,16.18 12.16,16.34 C12.74,16.5 13.24,17 13.24,17.58 C13.24,18.16 12.76,18.58 12.16,18.42 Z M4.76,17.76 L4.76,21.52 L15.1,26.52 L15.1,22.52 L4.76,17.76 Z M12.16,24.24 C11.58,24.16 11.08,23.58 11.08,23 C11.08,22.42 11.58,22 12.16,22.16 C12.74,22.32 13.24,22.82 13.24,23.4 C13.24,24 12.76,24.42 12.16,24.24 Z"
}))))))));

function SvgGroup14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "124px",
    viewBox: "0 0 124 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u673A\u5668") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup14);
export default __webpack_public_path__ + "static/media/group1_4.31db67bf.svg";
export { ForwardRef as ReactComponent };